import { render, staticRenderFns } from "./EditNotificationExtra.vue?vue&type=template&id=08bfcd62&"
import script from "./EditNotificationExtra.vue?vue&type=script&lang=js&"
export * from "./EditNotificationExtra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports